import { lazy } from "react";
import { Box } from "@mui/material";
import { useNextStep, useWindowSize } from "../../../hooks";
import { TPage } from "../../../model";
import animationData from "../../../assets/lottie/part4FitnessAnalysis.json";
import * as S from "./style";

const CustomButton = lazy(() => import("../../../components/Base/CustomButtonV2/CustomButton"));
const GoalsUnionIcon = lazy(() => import("../../../components/Base/Svg/Icons/GoalsUnion"));
const GoalsIcon = lazy(() => import("../../../components/Base/Svg/Icons/Goals"));

const Part3FitnessAnalysis: React.FC<TPage> = ({ pageId, nextPagePath }) => {
  const { height } = useWindowSize();
  const handleContinue = useNextStep({ pageId, nextPagePath });

  return (
    <S.Main>
      <S.PageContent height={height}>
        <S.Content>
          <S.StyledLottie height={height} animationData={animationData} loop={true} />
          <S.HeaderText>
            <Box>
              <GoalsIcon />
            </Box>
            <S.PartText>Part 3</S.PartText>
            <Box>
              <GoalsUnionIcon />
            </Box>
          </S.HeaderText>
          <S.GoalsText>FITNESS ANALYSIS</S.GoalsText>
          <S.ContentText>
            <Box>
              Understanding your dancing habits can help you make your exercise routine more enjoyable. Your activity level helps us personalize your nutrition and exercise plan.
            </Box>
          </S.ContentText>
        </S.Content>
        <CustomButton width={height / 2} text="Continue" onClick={() => handleContinue()} />
      </S.PageContent>
    </S.Main>
  );
};

export default Part3FitnessAnalysis;
